import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { FIREBASE_CONFIG } from "../config/firebaseConfig";

const app = initializeApp(FIREBASE_CONFIG);
export const auth = getAuth(app);
/** The one Firebase app: sign-in above, and the device id (services/deviceId.js). */
export const firebaseApp = app;
